import { createAction } from '../../store/createAction';

export const requestFailed = createAction(
    'request/REQUEST_FAILED',
    (id: string, response: unknown) => ({
        id,
        response,
    }),
);
